import catalogPermissionsId from '@constants/catalogPermissionsId'

export default Object.freeze([
    {
        permissionId: catalogPermissionsId.CREAR_EDITAR_SECCION,
        availablePaths: [
            { path: "/sections" },
            { path: "/section/new" },
            { path: "/section/edit" },
        ]
    },
    {
        permissionId: catalogPermissionsId.MOSTRAR_OCULTAR_SECCION,
        availablePaths: [
            { path: "/sections" },
        ]
    },
    {
        permissionId: catalogPermissionsId.ELIMINAR_SECCION,
        availablePaths: [
            { path: "/sections" },
        ]
    },
    {
        permissionId: catalogPermissionsId.ORDENAR_SECCION,
        availablePaths: [
            { path: "/sections" },
        ]
    },
    {
        permissionId: catalogPermissionsId.ELIMINAR_SECCION_AUTORIZADAS,
        availablePaths: [
            { path: "/sections" },
        ]
    },
    {
        permissionId: catalogPermissionsId.EDITAR_TODAS_SECCIONES,
        availablePaths: [
            { path: "/section/edit" },
        ]
    },
    {
        permissionId: catalogPermissionsId.AGREGAR_DOCUMENTO,
        availablePaths: [
            { path: "/document/new" },
            { path: "/documents" },
        ]
    },
    {
        permissionId: catalogPermissionsId.EDITAR_DOCUENTO,
        availablePaths: [
            { path: "/document/edit" },
            { path: "/documents" },
        ]
    },
    {
        permissionId: catalogPermissionsId.MOSTRAR_OCULTAR_DOCUMENTO,
        availablePaths: [
            { path: "/documents" },
        ]
    },
    {
        permissionId: catalogPermissionsId.ELIMINAR_DOCUMENTOS_AUTORIZADOS,
        availablePaths: [
            { path: "/documents" },
        ]
    },
    {
        permissionId: catalogPermissionsId.VER_REPORTE_LECTORES,
        availablePaths: [
            { path: "/document/report" },
        ]
    },
    {
        permissionId: catalogPermissionsId.ORDENAR_DOCUMENTO,
        availablePaths: [
            { path: "/documents" },
        ]
    },
    {
        permissionId: catalogPermissionsId.VER_USUARIOS_INTERNOS,
        availablePaths: [
            { path: "/users/internal" },
        ]
    },
    {
        permissionId: catalogPermissionsId.CARGA_MASIVA_DE_USUARIOS_INTERNOS,
        availablePaths: [
            { path: "/users/internal/bulk-load" },
            { path: "/users/internal/import" },
        ]
    },
    {
        permissionId: catalogPermissionsId.CREAR_ADMINISTRADORES,
        availablePaths: [
            { path: "/admin/new" },
            { path: "/admins" },
        ]
    },
    {
        permissionId: catalogPermissionsId.AJUSTAR_INFORMACION_ADMINISTRADORES,
        availablePaths: [
            { path: "/admin/edit" },
            { path: "/admins" },
        ]
    },
    {
        permissionId: catalogPermissionsId.ELIMINAR_ADMINISTRADORES,
        availablePaths: [
            { path: "/admins" },
        ]
    },
    {
        permissionId: catalogPermissionsId.CREAR_PERFILES,
        availablePaths: [
            { path: "/profiles" },
            { path: "/profile/new" },
        ]
    },
    {
        permissionId: catalogPermissionsId.AJUSTAR_INFORMACION_PERFILES,
        availablePaths: [
            { path: "/profiles" },
            { path: "/profile/edit" },
        ]
    },
    {
        permissionId: catalogPermissionsId.ELIMINAR_PERFILES,
        availablePaths: [
            { path: "/profiles" },
        ]
    },
    {
        permissionId: catalogPermissionsId.CREAR_EMPRESA,
        availablePaths: [
            { path: "/business" },
            { path: "/company/new" },
        ]
    },
    {
        permissionId: catalogPermissionsId.AJUSTAR_EMPRESA,
        availablePaths: [
            { path: "/business" },
            { path: "/company/edit" },
        ]
    },
    {
        permissionId: catalogPermissionsId.AGREGAR_PAIS,
        availablePaths: [
            { path: "/countries" },
        ]
    },
    {
        permissionId: catalogPermissionsId.EDITAR_PAISES,
        availablePaths: [
            { path: "/countries" },
        ]
    },
    {
        permissionId: catalogPermissionsId.MOSTRAR_OCULTAR_PAISES,
        availablePaths: [
            { path: "/countries" },
        ]
    },
    {
      permissionId: catalogPermissionsId.AGREGAR_IDIOMAS,
      availablePaths: [
          { path: "/languages" },
      ]
  },
  {
      permissionId: catalogPermissionsId.EDITAR_IDIOMAS,
      availablePaths: [
          { path: "/languages" },
      ]
  },
  {
      permissionId: catalogPermissionsId.MOSTRAR_OCULTAR_IDIOMAS,
      availablePaths: [
          { path: "/languages" },
      ]
  },
  {
      permissionId: catalogPermissionsId.ELIMINAR_IDIOMAS,
      availablePaths: [
          { path: "/languages" },
      ]
  },
  {
      permissionId: catalogPermissionsId.ACCESO_CORREOS,
      availablePaths: [
          { path: "/emails" },
      ]
  },
  {
      permissionId: catalogPermissionsId.ACCESO_REPORTES,
      availablePaths: [
          { path: "/reports" },
      ]
  },
  {
      permissionId: catalogPermissionsId.LISTA_NEGRA_DE_DOMINIOS,
      availablePaths: [
          { path: "/blacklist-domains" },
      ]
  },
  {
      permissionId: catalogPermissionsId.ADMINISTRAR_EVALUADORES,
      availablePaths: [
          { path: "/evaluators" },
      ]
  },
  {
      permissionId: catalogPermissionsId.ADMINISTRAR_GESTORES,
      availablePaths: [
          { path: "/evaluators" },
      ]
  },
  {
      permissionId: catalogPermissionsId.ADMINISTRAR_COORDINADORES,
      availablePaths: [
          { path: "/evaluators" },
      ]
  },
  {
      permissionId: catalogPermissionsId.ADMINISTRAR_ROLES,
      availablePaths: [
          { path: "/roles" },
      ]
  },
  {
      permissionId: catalogPermissionsId.ADMINISTRAR_DICCIONARIO_PROCESOS,
      availablePaths: [
          { path: "/process-dictionary" },
          { path: "/process-dictionary/traslate" },
      ]
  },
  {
      permissionId: catalogPermissionsId.ADMINISTRAR_ANEXOS_PROCESOS,
      availablePaths: [
          { path: "/anexos" },
      ]
  },
  {
      permissionId: catalogPermissionsId.ADMINISTRAR_PROVEDOR,
      availablePaths: [
          { path: "/supplier/search" },
          { path: "/supplier/detail" },
      ]
  },
  {
      permissionId: catalogPermissionsId.ACCESO_BITACORA,
      availablePaths: [
          { path: "/bitacora" }
      ]
  },
  {
      permissionId: catalogPermissionsId.VALIDAR_SELLO_DIGITAL,
      availablePaths: [
          { path: "/validate-digital-stamp" }
      ]
  },
  {
      permissionId: catalogPermissionsId.EDICION_DE_ANEXO_FD,
      availablePaths: [
          { path: "/digital-form" },
          { path: "/digital-form/edit" }
        ]
    },
    {
        permissionId: catalogPermissionsId.TRADUCCION_DE_TEXTOS_FD,
        availablePaths: [
            { path: "/digital-form" },
            { path: "/digital-form/edit" }
        ]
    },
    {
        permissionId: catalogPermissionsId.AUTORIZAR_RECHAZAR_FD,
        availablePaths: [
            { path: "/digital-form" },
            { path: "/digital-form/edit" }
        ]
    },
    {
        permissionId: catalogPermissionsId.TRADUCCION_INACTIVOS_FD,
        availablePaths: [
            { path: "/digital-form" },
            { path: "/digital-form/edit" }
      ]
  },
])
